import { useEffect } from "react";

const SEO = ({ pageTitle }) => {
  useEffect(() => {
    // This will now exactly match the titles we set up on your pages!
    document.title = pageTitle;
  }, [pageTitle]); // Added pageTitle here to follow React best practices
};

export default SEO;